export function getUrlToken(): string | null {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("token");
}